export default "__VITE_ASSET__6218ad35__"